import { Link } from "react-router-dom";
import { AREAS, BRAND, SERVICES } from "@/data/site";
import { Logo } from "./Header";
import MapEmbed from "./MapEmbed";

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-[#0B0D10]" data-testid="site-footer">
      <div className="border-b border-slate-800">
        <div className="mx-auto max-w-7xl px-5 pt-14 md:px-8">
          <p className="eyebrow mb-4">Find us</p>
        </div>
        <MapEmbed />
      </div>
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-4 md:px-8">
        <div className="space-y-4">
          <Logo />
          <p className="text-sm leading-relaxed text-slate-400">
            Commercial & industrial flooring specialists servicing the Gold Coast, northern corridor, Logan and Northern Rivers NSW.
          </p>
          <p className="font-mono text-xs text-slate-500">{BRAND.licence}</p>
        </div>
        <div>
          <h3 className="eyebrow mb-4">Services</h3>
          <ul className="space-y-2">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-slate-300 hover:text-brand-400">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="eyebrow mb-4">Service Areas</h3>
          <ul className="space-y-2">
            {AREAS.map((a) => (
              <li key={a.slug}>
                <Link to={`/areas/${a.slug}`} data-testid={`footer-area-${a.slug}`} className="text-sm text-slate-300 hover:text-brand-400">
                  {a.name} {a.postcode}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-3">
          <h3 className="eyebrow mb-4">Contact</h3>
          <a href={BRAND.phoneHref} data-testid="footer-phone" className="block font-display text-2xl font-bold text-white hover:text-brand-400">{BRAND.phone}</a>
          <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="block break-all text-sm text-slate-300 hover:text-brand-400">{BRAND.email}</a>
          <p className="text-sm text-slate-400">Mon–Fri 6:30am–5pm · Night & weekend works available</p>
          <address className="text-sm not-italic text-slate-400" data-testid="footer-address">{BRAND.street}, {BRAND.suburb} {BRAND.region} {BRAND.postcode}</address>
          <Link to="/blog" data-testid="footer-blog" className="block text-sm text-slate-300 hover:text-brand-400">Blog & news</Link>
          <Link to="/staff/login" data-testid="footer-staff-login" className="inline-block pt-4 font-mono text-xs uppercase tracking-widest text-slate-600 hover:text-slate-400">Staff login</Link>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center font-mono text-xs text-slate-600">
        © {new Date().getFullYear()} {BRAND.name}. Gold Coast, QLD.
      </div>
    </footer>
  );
}
